import { render, staticRenderFns } from "./ProductConfirmationError.vue?vue&type=template&id=d5bed774&scoped=true&"
import script from "./ProductConfirmationError.vue?vue&type=script&lang=js&"
export * from "./ProductConfirmationError.vue?vue&type=script&lang=js&"
import style0 from "./ProductConfirmationError.vue?vue&type=style&index=0&id=d5bed774&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5bed774",
  null
  
)

export default component.exports